module.exports = __webpack_public_path__ + "static/media/setting.04703d37.svg";